import React, { useState, useEffect } from "react";
export default function DarkLightButton() {
  const [darkTheme, setDarkTheme] = useState(true);
  useEffect(() => {
    const root = document.documentElement;
    root?.style.setProperty("--black", darkTheme ? "#161823" : "#FFFFFF");
    root?.style.setProperty("--white", darkTheme ? "#FFFFFF" : "#161823");
  }, [darkTheme]);

 

  return (
    <button className="darklight-btn" onClick={() => setDarkTheme(!darkTheme)}>
      {darkTheme ? (
        <i class="fa-solid fa-moon"></i>
      ) : (
        <i class="fa-solid fa-sun"></i>
        
      )}
    </button>
  );
}
